var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t(_vm.config.label),"state":null}},[_c('flat-pickr',{staticClass:"form-control",attrs:{"state":null,"value":[_vm.request[_vm.config.startKey], _vm.request[_vm.config.endKey]],"config":{
            dateFormat: 'Y-m-d H:i:S',
            enableTime: true,
            enableSeconds: true,
            defaultHour: 0,
            mode: 'range',
            time_24hr: true
        },"placeholder":"YYYY-MM-DD HH:ii:ss"},on:{"input":function (newValue){

            newValue = newValue.split(' to ')

            _vm.$emit('updateRequest', {
              key:_vm.config.startKey,
              value:newValue[0]
            })

            _vm.$emit('updateRequest', {
              key:_vm.config.endKey,
              value:newValue[1]
            })

        }}}),(_vm.errors && (_vm.config.startKey in _vm.errors))?_c('b-form-invalid-feedback',{attrs:{"state":_vm.errors && (_vm.config.startKey in _vm.errors) ? false : null}},[_vm._v(" "+_vm._s(_vm.$t(_vm.errors[_vm.config.startKey][0]))+" ")]):_vm._e(),(_vm.errors && (_vm.config.endKey in _vm.errors))?_c('b-form-invalid-feedback',{attrs:{"state":_vm.errors && (_vm.config.endKey in _vm.errors) ? false : null}},[_vm._v(" "+_vm._s(_vm.$t(_vm.errors[_vm.config.endKey][0]))+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }